import { createRouter, createWebHistory } from 'vue-router'
import Home from '../components/Home.vue'
import SignUp from '../components/SignUp.vue'
import LinkedGuestPass from '../components/LinkedGuestPass.vue'
//import TestSignUp from '../components/TestSignUp.vue'
import NotFound from '../components/NotFound.vue'

const routes = [
  {
    path: '/',
    name: 'Home',

    component: Home
  },
  {
    path: '/:id',
    name: 'SignUp',

    component: SignUp,
    props: true
    //props: { 
      //type:[Number],
      //required:true
  //}
  },
  {
    path: '/pass/:linked',
    name: 'LinkedGuestPass',
    component: LinkedGuestPass,
    props: true
  },
  //{
  // path: '/test',
  // name: 'TestSignUp',
  // component: TestSignUp,
  // props: true
  //},
  {
    path: "/:catchAll(.*)",
    name: 'NotFound',
    component: NotFound,
  },

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
